export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/d9f26165e744ef064b81249371ce3c44.svg";